"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var noop = function noop() {};

var enterKeyCode = 13;

var isTextTruthy = function isTextTruthy(val) {
  return val !== undefined && val !== null && val.toString() !== '';
};

var sizeStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  visibility: 'hidden',
  height: 0,
  overflow: 'scroll',
  whiteSpace: 'pre'
};

var InlineEdit = function InlineEdit(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      placeholder = _ref.placeholder,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$requiredWarningM = _ref.requiredWarningMessage,
      requiredWarningMessage = _ref$requiredWarningM === void 0 ? 'This Field is Required' : _ref$requiredWarningM,
      id = _ref.id,
      onChange = _ref.onChange,
      onSave = _ref.onSave,
      _ref$onCancel = _ref.onCancel,
      onCancel = _ref$onCancel === void 0 ? noop : _ref$onCancel,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? noop : _ref$onFocus,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? noop : _ref$onBlur,
      forwardedRef = _ref.forwardedRef;

  // States for Inline Edit
  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showInput = _useState4[0],
      setShowInput = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      inputWidth = _useState6[0],
      setInputWidth = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      savedTimer = _useState8[0],
      setSavedTimer = _useState8[1];

  var _useState9 = (0, _react.useState)(['resting-text']),
      _useState10 = _slicedToArray(_useState9, 2),
      restingClassNames = _useState10[0],
      setRestingClassNames = _useState10[1];

  var _useState11 = (0, _react.useState)(id || (0, _v["default"])()),
      _useState12 = _slicedToArray(_useState11, 1),
      inputId = _useState12[0]; // Keeps the inputId from changing with each render.
  // ensure we clear any timers in case component unmounts.


  (0, _react.useEffect)(function () {
    return function () {
      return clearTimeout(savedTimer);
    };
  }, [savedTimer]);
  var wrapperClasses = "inline-edit-group".concat(required ? ' required' : '');
  var hasOnChange = Boolean(onChange);
  var displayValue = hasOnChange ? value : localValue;
  var isRequiredAndEmpty = !isTextTruthy(displayValue) && required;
  var inputRef = (0, _react.useRef)();
  /**
   * This hook is used to customize the instance value exposed to the parent for the ref.
   * It must always be used with React.forwardRef. This gives us control of where to pass the ref prop.
   * Whatever ref is passed to Inline Edit will receive the inputRef instance.
   * This pattern supports all methods of creating refs.
   */

  (0, _react.useImperativeHandle)(forwardedRef, function () {
    return inputRef.current;
  }); // used to calculate sizing for input to grow with text

  var valueSizeRef = (0, _react.useRef)();
  var placeholderSizeRef = (0, _react.useRef)();

  var updateWidth = function updateWidth() {
    var minWidth = 130;
    var extraPadding = 70;
    var newWidth = isTextTruthy(displayValue) ? valueSizeRef.current.scrollWidth : placeholderSizeRef.current.scrollWidth;

    if (newWidth < minWidth) {
      newWidth = minWidth;
    }

    newWidth += extraPadding;
    setInputWidth(newWidth);
  };

  var showSuccess = function showSuccess() {
    setRestingClassNames([].concat(_toConsumableArray(restingClassNames), ['saved']));
    setShowInput(false);
    setSavedTimer(setTimeout(function () {
      return setRestingClassNames(restingClassNames.filter(function (className) {
        return className !== 'saved';
      }));
    }, 1000));
  };

  var handleBlur = function handleBlur(e) {
    if (hasOnChange) {
      setShowInput(false);
      showSuccess();
    }

    updateWidth();
    onBlur(e);
  };

  var handleFocus = function handleFocus(e) {
    onFocus(e);
    updateWidth();
  };

  var handleChange = function handleChange(e) {
    var inputValue = e.target.value;

    if (hasOnChange) {
      onChange(e);
    } else {
      setLocalValue(inputValue);
    }

    updateWidth();
  };

  var onEnter = function onEnter(e) {
    if (e.keyCode === enterKeyCode) {
      if (!hasOnChange) {
        if (isRequiredAndEmpty) {
          return;
        }

        onSave({
          value: localValue,
          name: name
        }, e);
      }

      showSuccess();
    }
  };

  var handleSaveClick = function handleSaveClick(e) {
    if (isRequiredAndEmpty) {
      return;
    }

    onSave({
      value: localValue,
      name: name
    }, e);
    updateWidth();
    showSuccess();
  }; // Optional to handle how we cancel our input


  var handleCancelClick = function handleCancelClick(e) {
    onCancel({
      value: localValue,
      name: name
    }, e);
    setLocalValue(value);
    updateWidth();
    setShowInput(false);
  };

  var handleActiveClick = function handleActiveClick() {
    setShowInput(true);
  };

  var inputProps = {
    name: name,
    type: type,
    value: displayValue,
    label: label,
    placeholder: placeholder,
    id: inputId,
    onKeyDown: onEnter,
    ref: inputRef,
    onBlur: handleBlur,
    onFocus: handleFocus,
    onChange: handleChange,
    autoFocus: true
  };
  var inputStyle = {
    marginBottom: '20px',
    width: "".concat(inputWidth, "px")
  };
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: wrapperClasses,
    style: inputStyle
  }, showInput ? _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("input", inputProps), label ? _react["default"].createElement("label", {
    className: "control-label",
    htmlFor: inputId
  }, label) : null, !hasOnChange ? _react["default"].createElement("div", {
    className: "right-addon"
  }, _react["default"].createElement("button", {
    onClick: handleSaveClick,
    "aria-label": "save"
  }, _react["default"].createElement("i", {
    className: "fa fa-check"
  })), _react["default"].createElement("button", {
    onClick: handleCancelClick,
    "aria-label": "cancel"
  }, _react["default"].createElement("i", {
    className: "fa fa-times"
  }))) : null) : _react["default"].createElement("span", {
    className: restingClassNames.join(' ')
  }, _react["default"].createElement("p", {
    onClick: handleActiveClick
  }, displayValue || placeholder), label ? _react["default"].createElement("div", {
    className: "resting-label"
  }, label) : null), isRequiredAndEmpty ? _react["default"].createElement("div", {
    className: "error-message"
  }, requiredWarningMessage) : null), _react["default"].createElement("div", {
    ref: valueSizeRef,
    style: sizeStyle
  }, displayValue), placeholder ? _react["default"].createElement("div", {
    ref: placeholderSizeRef,
    style: sizeStyle
  }, placeholder) : null);
};

InlineEdit.propTypes = {
  name: _propTypes["default"].string,
  label: _propTypes["default"].node,
  placeholder: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  id: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  requiredWarningMessage: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onSave: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  forwardedRef: _propTypes["default"].oneOf([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })])
};

var _default = (0, _react.forwardRef)(function (props, ref) {
  return _react["default"].createElement(InlineEdit, _extends({}, props, {
    forwardedRef: ref
  }));
});

exports["default"] = _default;